import { NamedResourceCRUDPage } from "../components/named_resource_crud";
import { tagsAdapter } from "../components/tags/tagsAdapter";

export function TagsPage() {
  return <NamedResourceCRUDPage adapter={tagsAdapter} />;
}
